import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const DoctorsPromoCorner: React.FC = () => {
  const [closed, setClosed] = useState(false);

  if (closed) return null;

  return (
    <div className="fixed top-36 left-3 z-40 w-[230px] md:w-[260px]">
      <div className="relative rounded-2xl border border-primary/30 bg-background/95 p-4 shadow-xl backdrop-blur-sm">
        <button
          type="button"
          onClick={() => setClosed(true)}
          aria-label="بستن تبلیغ"
          className="absolute left-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-full bg-muted text-muted-foreground transition hover:bg-muted/80 hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="mt-1 space-y-2 text-right">
          <h3 className="text-sm font-semibold leading-6">دکتر رقیه فلاح</h3>
          <span className="inline-flex w-fit rounded-full bg-primary/10 px-2.5 py-1 text-[11px] font-medium text-primary">
            متخصص اطفال
          </span>
          <p className="text-xs leading-5 text-muted-foreground">
            آدرس: شهرقدس میدان سرقنات ساختمان پزشکان زارع
          </p>
        </div>

        <Button size="sm" className="mt-3 w-full" asChild>
          <a href="tel:+982146817262">تماس با مطب</a>
        </Button>

        <Button size="sm" variant="outline" className="mt-2 w-full" asChild>
          <Link to="/doctors">لیست همه پزشکان</Link>
        </Button>
      </div>
    </div>
  );
};

export default DoctorsPromoCorner;
